/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SegmentsWarning/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SegmentsWarning({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/SMSTemplateEditor/Content/SegmentsWarning"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let editorSegmentsValueData = fromData.useDataFormat({ viewPath,
context: 'editor',
path: 'segments',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(editorSegmentsValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}